import nxModule from 'nxModule';
import CmcService from "../../../../react/system/CmcService";

nxModule.service('cmcService', CmcService);